import React from 'react';
import styled from 'styled-components';

import ArrowSvg from './arrow.svg';

const LeftArrow = styled.img`
    opacity: 0.2;
    transition: opacity 0.2s ease-in;
    height: ${({ height }) => height};
    width: ${({ width }) => width};
    cursor: pointer;

    &:hover {
        opacity: 1;
    }
    @media (max-width: 640px) {
        display: none;
    }
`;

const RightArrow = styled(LeftArrow)`
    left: 0;
    right: ${({ distance }) => `calc(${distance} / -2)`};
    transform: scaleX(-1);
`;

const Container = styled.div`
    justify-content: space-between;
    position: absolute;
    z-index: 3;
    pointer-events: none;
    
    ${({ visibleCardWidth }) => visibleCardWidth ? `@media(max-width: ${visibleCardWidth}px) {display: none;}` : null}

    ${({ vertical, height, distance }) =>
        vertical
            ? `
                width: ${height};
                height: calc(100% + ${distance});
                left: calc(50% - ${height} / 2);
                top: calc(${distance} / -2);
                flex-direction: column;
                
                & ${LeftArrow} {
                    transform: rotate(90deg) translate(0, -100%);
                    transform-origin: 0 0;
                }
                
                & ${RightArrow} {
                    bottom: calc(${distance} / -2);
                    transform: rotate(90deg) scaleX(-1);
                    transform-origin: 0 100%;
                }
            `
            : `
                width: calc(100% + ${distance});
                top: calc(50% - ${height} / 2);
                left: calc(${distance} / -2);
                margin-top: -30px;
            `
    }
`;

const ArrowWrap = styled.div`
    pointer-events: auto;
    visibility: ${p => p.isHide ? 'hidden' : 'visible'};
`;

class DefaultArrows extends React.Component {

    parameterToStyle = (parameter) => isNaN(parameter) ? parameter : `${parameter}px`;

    render() {
        const {
            swipeLeft,
            swipeRight,
            visibleCardWidth,
            vertical = false,
            hideLeftArrow = false,
            hideRightArrow = false,
            config: { width = 'fit-content', height = 30, distance = 60 },
        } = this.props;

        return (
            <Container
                visibleCardWidth={visibleCardWidth}
                vertical={vertical}
                height={this.parameterToStyle(height)}
                distance={this.parameterToStyle(distance)}
            >
                <ArrowWrap isHide={hideLeftArrow}>
                    <LeftArrow
                        key='left'
                        src={ArrowSvg}
                        onClick={swipeLeft}
                        height={this.parameterToStyle(height)}
                        width={this.parameterToStyle(width)}
                    />
                    </ArrowWrap>
                <ArrowWrap isHide={hideRightArrow}>
                    <RightArrow
                        key='right'
                        src={ArrowSvg}
                        onClick={swipeRight}
                        height={this.parameterToStyle(height)}
                        width={this.parameterToStyle(width)}
                        distance={this.parameterToStyle(distance)}
                    />
                </ArrowWrap>
            </Container>
        );
    }
}

export default DefaultArrows;
